// extracted by mini-css-extract-plugin
export default {"root":"ConditionConfigCard_root__alk0x","popover":"ConditionConfigCard_popover__1wzPZ"};